<template>
<div class="chapter">
<div class="inner_page">
<p class="ct">Contents</p>
<p class="corn">•    •    •    •    •</p>
<p class="ctfm"><a href="#/f007">Prologue: Awash in Red</a></p>
<p class="ctpn"><a href="#/f008">PART ONE: BIRTH OF A BOOTLEGGER</a></p>
<p class="ctct"><a href="#/f009">  <span class="ccn">1</span> Napoleon of the Bar</a></p>
<p class="ctct"><a href="#/f010">  <span class="ccn">2</span> Illicit Relations</a></p>
<p class="ctct"><span href="#/f011" title="Link target outside of Sample">  <span class="ccn">3</span> Birth of a Bootlegger</span></p>
<p class="ctpn"><span href="#/f012" title="Link target outside of Sample">PART TWO: KING OF THE BOOTLEGGERS</span></p>
<p class="ctct"><span href="#/f013" title="Link target outside of Sample">  <span class="ccn">4</span> The Bourbon Empire</span></p>
<p class="ctct"><span href="#/f014" title="Link target outside of Sample">  <span class="ccn">5</span> Underworld Boss of Death Valley</span></p>
<p class="ctct"><span href="#/f015" title="Link target outside of Sample">  <span class="ccn">6</span> Every Man Has His Price</span></p>
<p class="ctct"><span href="#/f016" title="Link target outside of Sample">  <span class="ccn">7</span> Epic Grandeur</span></p>
<p class="ctpn"><span href="#/f017" title="Link target outside of Sample">PART THREE: PLUNDERING AN EMPIRE</span></p>
<p class="ctct"><span href="#/f018" title="Link target outside of Sample">  <span class="ccn">8</span> Ace Bags the King</span></p>
<p class="ctct"><span href="#/f019" title="Link target outside of Sample">  <span class="ccn">9</span> Business as Usual</span></p>
<p class="ctct"><span href="#/f020" title="Link target outside of Sample"><span class="ccn">10</span> Life in Hell</span></p>
<p class="ctct"><span href="#/f021" title="Link target outside of Sample"><span class="ccn">11</span> Freedom</span></p>
<p class="ctct"><span href="#/f022" title="Link target outside of Sample"><span class="ccn">12</span> Heavy Lover</span></p>
<p class="ctct"><span href="#/f023" title="Link target outside of Sample"><span class="ccn">13</span> Plundering the Bourbon Empire</span></p>
<p class="ctpn"><span href="#/f024" title="Link target outside of Sample">PART FOUR: A VERY DANGEROUS MAN</span></p>
<p class="ctct"><span href="#/f025" title="Link target outside of Sample"><span class="ccn">14</span> A Shot Rings Out</span></p>
<p class="ctct"><span href="#/f026" title="Link target outside of Sample"><span class="ccn">15</span> “Ready for the Battle—It’s a Fight!”</span></p>
<p class="ctct"><span href="#/f027" title="Link target outside of Sample"><span class="ccn">16</span> Cutthroats and Assassins</span></p>
<p class="ctct"><span href="#/f028" title="Link target outside of Sample"><span class="ccn">17</span> Let’s Give Him a Nice Christmas</span></p>
<p class="ctpn"><span href="#/f029" title="Link target outside of Sample">PART FIVE: LOST MILLIONS</span></p>
<p class="ctct"><span href="#/f030" title="Link target outside of Sample"><span class="ccn">18</span> Rise of the Gangster</span></p>
<p class="ctct"><span href="#/f031" title="Link target outside of Sample"><span class="ccn">19</span> Dodge’s Demise</span></p>
<p class="ctct"><span href="#/f032" title="Link target outside of Sample"><span class="ccn">20</span> Remus v. Prohibition</span></p>
<p class="ctbm"><span href="#/f033" title="Link target outside of Sample">Epilogue: Fall of the Bootleg Baron</span></p>
<p class="ctfm"><span href="#/f034" title="Link target outside of Sample">Timeline</span></p>
<p class="ctfm"><span href="#/f039" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// f006.vue?171af904